<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import { getTenant } from "../getTenant.js";
	import Link from "../components/Link.svelte";
	import StaticPicture from "../components/Picture/StaticPicture.svelte";
	import { ourApproachAnchorMap } from "../../../core/schema/anchors/ourApproachAnchorMap.js";
	import translations from "./OurApproach.translations.json";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";
	import image1 from "../assets/images/ourApproach/img1.jpg?webp&w=768&imagetools";
	import image2 from "../assets/images/ourApproach/img2.jpg?webp&w=768&imagetools";
	import image3 from "../assets/images/ourApproach/img3.jpg?webp&w=768&imagetools";
	import image4 from "../assets/images/ourApproach/img4.jpg?webp&w=768&imagetools";
	import image5 from "../assets/images/ourApproach/img5.jpg?webp&w=768&imagetools";
	import { getTranslate } from "../utils/getTranslate.js";
	import { contactPathMap } from "../../../core/schema/paths/contactPathMap";
	import ContactForm from "../components/Contact/ContactForm.svelte";
	import { nbspify } from "../../../core/utils/nbspify.js";

	const translate = getTranslate(translations);
	const tenant = getTenant();

	const approaches = [
		{
			number: "01",
			id: ourApproachAnchorMap.processAnalysis[tenant.locale],
			title: translate("ourApproach1Title"),
			description: translate("ourApproach1Desc"),
			image: image1,
		},
		{
			number: "02",
			id: ourApproachAnchorMap.concept[tenant.locale],
			title: translate("ourApproach2Title"),
			description: translate("ourApproach2Desc"),
			image: image2,
		},
		{
			number: "03",
			id: ourApproachAnchorMap.detailedDesign[tenant.locale],
			title: translate("ourApproach3Title"),
			description: translate("ourApproach3Desc"),
			image: image3,
		},
		{
			number: "04",
			id: ourApproachAnchorMap.implementation[tenant.locale],
			title: translate("ourApproach4Title"),
			description: translate("ourApproach4Desc"),
			image: image4,
		},
		{
			number: "05",
			id: ourApproachAnchorMap.serviceAndSupport[tenant.locale],
			title: translate("ourApproach5Title"),
			description: translate("ourApproach5Desc"),
			image: image5,
		},
	];
</script>

<Layout>
	<div class="container">
		<section class="mx-4 !mb-16 md:mx-0 md:!mb-24">
			<div class="flex items-center gap-4 md:mx-16 xl:mx-32">
				<span class="bg-ltprimary-200 h-px w-8"></span>
				<span class="text-ltprimary-200 uppercase">{translate("tag")}</span>
			</div>
			<div class="mt-16 flex flex-col gap-2 md:mx-16 md:gap-8 xl:mx-32 xl:flex-row xl:gap-32">
				<div class="flex-1 xl:max-w-[40%]">
					<h1 class="text-ltprimary p-0 text-center font-light uppercase tracking-wider md:text-left">
						{translate("introductoryHeadline")}
					</h1>
				</div>
				<div class="text-ltsecondary ml-auto max-w-3xl flex-1">
					<div class="lg:text-md/normal mb-5 font-light tracking-[0.02em]">{translate("introductoryDesc")}</div>
					<Link
						asButton
						variant="secondary"
						class="mt-12 xl:mt-16"
						icon={arrowRight}
						href="/{contactPathMap[tenant.locale]}">{translate("contactUs")}</Link
					>
				</div>
			</div>
		</section>
	</div>

	<section class="mb-0">
		<div class="border-lttertiary border-t">
			{#each approaches as approach, i (approach.number)}
				<div id={approach.id} class="border-lttertiary scroll-mt-24 border-b">
					<div class="mx-auto max-w-[120rem]">
						<div class="px-4 md:px-16 lg:px-32">
							<div class="border-lttertiary relative grid grid-cols-1 border-x xl:grid-cols-2">
								<div class="bg-lttertiary absolute inset-y-0 left-1/2 hidden w-px xl:block"></div>

								<div class="order-2 px-8 pb-8 pt-0 xl:order-1 xl:p-8" class:xl:!order-2={i % 2 !== 0}>
									<StaticPicture
										image={approach.image}
										alt={approach.title}
										width={768}
										height={448}
										imgClass="h-[28rem] w-[48rem] max-w-full object-cover"
									/>
								</div>

								<div class="order-1 flex flex-col p-8 xl:order-2" class:xl:!order-1={i % 2 !== 0}>
									<div class="text-ltprimary font-bahnschrift mb-8 text-base font-light uppercase tabular-nums xl:mb-0">
										{approach.number}
									</div>
									<div class="my-auto">
										<h2 class="text-ltprimary mb-4 font-light uppercase tracking-[0.02em]">
											{nbspify(approach.title)}
										</h2>
										<p class="mb-0 max-w-[35.375rem] text-base/[1.6] font-normal tracking-[0.02em]">
											{nbspify(approach.description)}
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			{/each}
		</div>
	</section>

	<section id={ourApproachAnchorMap.contactUs[tenant.locale]} class="scroll-mt-24">
		<ContactForm />
	</section>
</Layout>
